import { render, staticRenderFns } from "./turnTable.vue?vue&type=template&id=d60d0ea8&scoped=true&"
import script from "./turnTable.vue?vue&type=script&lang=js&"
export * from "./turnTable.vue?vue&type=script&lang=js&"
import style0 from "./turnTable.vue?vue&type=style&index=0&id=d60d0ea8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60d0ea8",
  null
  
)

export default component.exports